import React, { useEffect, useRef, useState } from "react";
import styles from "./HotelCard.module.scss";
import tirthan from "../../../assets/new-images/destination-5.jpg";
import { animateScroll as scroll } from "react-scroll";
import imgNotFound from "../../../assets/images/single-image.png";
import { formatIndianCurrency } from "../../../utils/utils";
import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";

const HotelCard = ({ heading, titleLeft = false }) => {
  const [hotelData, setHotelData] = useState([]);
  const [loader, setLoader] = useState(false);

  const postBookingData = async () => {
    setLoader(true);
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

    const formdata = new FormData();

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/hotel-engine/check-availability`,
        requestOptions
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const result = await response.json();
      setHotelData(result?.data?.properties);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.error("Error fetching properties:", error);
    }
  };

  useEffect(() => {
    postBookingData();
  }, []);

  const [truncationMap, setTruncationMap] = useState({});

  useEffect(() => {
    const newMap = {};
    hotelData?.slice(0, 6)?.forEach((_, idx) => {
      const el = document.getElementById(`title-${idx}`);
      if (el) {
        newMap[idx] = el.scrollWidth > el.clientWidth;
      }
    });
    setTruncationMap(newMap);
  }, [hotelData]);

  return (
    <div className="container">
      <div className={styles.heading_div}>
        <h3 className="new_ui_heading">{heading}</h3>
        <Link to={"/all-hotels"} className={styles.view_all_btn}>
          View All
        </Link>
      </div>

      <div className="desktop_card_sec">
        {loader ? (
          <div className={`${styles.hotel_flex_card_sec} m_0`}>
            {Array.from({ length: 6 }).map((items, index) => (
              <div
                key={index}
                className={styles.hotel_card}
                style={{
                  background: "none",
                  marginBottom: "0px",
                  boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                  padding: "0px",
                }}
              >
                <div className={styles.img_sec}>
                  <Skeleton height="100%" width="100%" />
                </div>
                <div className="card_content" style={{ marginTop: "0px" }}>
                  <h6>
                    <Skeleton width="40%" />
                  </h6>
                  <h6>
                    <Skeleton width="40%" />
                  </h6>
                  <h6>
                    <Skeleton width="100%" />
                  </h6>
                  <h6>
                    <Skeleton width="24%" />
                  </h6>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className={`${styles.hotel_flex_card_sec} m_0`}>
            {hotelData?.slice(0, 3)?.map((items, index) => {
              // const today = new Date();
              // const tomorrow = new Date();
              // tomorrow.setDate(today.getDate() + 1); 

              // const checkinDay = today.getDate();
              // const checkinMonth = today.getMonth() + 1;
              // const checkinYear = today.getFullYear();

              // const checkoutDay = tomorrow.getDate();
              // const checkoutMonth = tomorrow.getMonth() + 1;
              // const checkoutYear = tomorrow.getFullYear();

              const checkinDate = new Date();
              checkinDate.setDate(checkinDate.getDate() + 7); // One week from today
            
              const checkoutDate = new Date();
              checkoutDate.setDate(checkoutDate.getDate() + 8); // Next day after check-in
            
              const checkinDay = checkinDate.getDate();
              const checkinMonth = checkinDate.getMonth() + 1;
              const checkinYear = checkinDate.getFullYear();
            
              const checkoutDay = checkoutDate.getDate();
              const checkoutMonth = checkoutDate.getMonth() + 1;
              const checkoutYear = checkoutDate.getFullYear();

              return (
                <a
                  onClick={() =>
                    scroll.scrollToTop({
                      duration: 500,
                      smooth: "easeInOutQuad",
                    })
                  }
                  href={`/single-hotel/${items?.hotel_slug}/${items?.hotel_id}?location=${items?.hotel_city}&room=1&adult=2&children=0&checkinDay=${checkinDay}&checkinMonth=${checkinMonth}&checkinYear=${checkinYear}&checkoutDay=${checkoutDay}&checkoutMonth=${checkoutMonth}&checkoutYear=${checkoutYear}&hotel_name=${items?.hotel_name}&hotel_address=${items?.hotel_address}`}
                  key={index}
                  className={styles.hotel_card}
                >
                  {" "}
                  <div className={styles.img_sec}>
                    {items.hotel_image && items.hotel_image.length > 0 ? (
                      <img src={items?.hotel_image[0]} alt={items?.alt} />
                    ) : (
                      <img src={imgNotFound} alt="Image not found" />
                    )}
                  </div>
                  <div className={styles.content_sec}>
                    <div>
                      {" "}
                      <span>
                        {" "}
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <mask
                            id="mask0_5983_7301"
                            style={{ maskType: "alpha" }}
                            maskUnits="userSpaceOnUse"
                            x="0"
                            y="0"
                            width="18"
                            height="18"
                          >
                            <rect width="18" height="18" fill="#D9D9D9" />
                          </mask>
                          <g mask="url(#mask0_5983_7301)">
                            <path
                              d="M9.0013 8.89894C9.37443 8.89894 9.69343 8.76606 9.9583 8.50031C10.2233 8.23456 10.3558 7.91512 10.3558 7.542C10.3558 7.16887 10.2229 6.84981 9.95718 6.58481C9.69143 6.31994 9.37193 6.1875 8.99868 6.1875C8.62555 6.1875 8.30655 6.32038 8.04168 6.58613C7.77668 6.85188 7.64418 7.17138 7.64418 7.54463C7.64418 7.91775 7.77705 8.23675 8.0428 8.50163C8.30855 8.7665 8.62805 8.89894 9.0013 8.89894ZM8.99999 14.6351C10.4672 13.3216 11.5901 12.0618 12.3684 10.8555C13.1468 9.64925 13.536 8.59275 13.536 7.686C13.536 6.31875 13.1016 5.19475 12.2329 4.314C11.3641 3.43325 10.2865 2.99287 8.99999 2.99287C7.71349 2.99287 6.63586 3.43325 5.76711 4.314C4.89836 5.19475 4.46399 6.31875 4.46399 7.686C4.46399 8.59275 4.85318 9.64925 5.63155 10.8555C6.40993 12.0618 7.53274 13.3216 8.99999 14.6351ZM8.99999 16.1321C7.11249 14.4966 5.69711 12.9746 4.75386 11.5659C3.81061 10.1572 3.33899 8.86387 3.33899 7.686C3.33899 5.95525 3.8988 4.55406 5.01843 3.48244C6.13818 2.41081 7.46536 1.875 8.99999 1.875C10.5346 1.875 11.8618 2.41081 12.9816 3.48244C14.1012 4.55406 14.661 5.95525 14.661 7.686C14.661 8.86387 14.1894 10.1572 13.2461 11.5659C12.3029 12.9746 10.8875 14.4966 8.99999 16.1321Z"
                              fill="#1C1B1F"
                            />
                          </g>
                        </svg>
                        {items.hotel_city}
                      </span>
                      <div className={styles.titleContainer} key={index}>
                        <h4
                          id={`title-${index}`}
                          className={styles.truncatedTitle}
                          style={{ padding: "0" }}
                        >
                          {items?.hotel_name}
                        </h4>
                        {truncationMap[index] && (
                          <span className={styles.fullTitle}>
                            {items?.hotel_name}
                          </span>
                        )}
                      </div>
                    </div>
                    <div>
                      {" "}
                      <span style={{ color: "#666666", textAlign: "end" }}>
                        {" "}
                        Starting From
                      </span>
                      <h3> {formatIndianCurrency(items.starting_price)}</h3>
                    </div>
                  </div>
                </a>
              );
            })}
          </div>
        )}
      </div>

      <div className="mobile_card_sec">
        {loader ? (
          <div className={styles.hotel_flex_card_sec}>
            <div
              className={styles.hotel_card}
              style={{
                background: "none",
                marginBottom: "0px",
                boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                padding: "0px",
              }}
            >
              <div className={styles.img_sec}>
                <Skeleton height="100%" width="100%" />
              </div>
              <div className="card_content" style={{ marginTop: "0px" }}>
                <h6>
                  <Skeleton width="40%" />
                </h6>
                <h6>
                  <Skeleton width="40%" />
                </h6>
                <h6>
                  <Skeleton width="100%" />
                </h6>
                <h6>
                  <Skeleton width="24%" />
                </h6>
              </div>
            </div>
          </div>
        ) : (
          <div className={styles.hotel_flex_card_sec}>
            <Swiper
              modules={[Pagination]}
              pagination={{ clickable: true }}
              loop={true}
              slidesPerView={1}
              className="mobile_card_slider"
            >
              {hotelData?.slice(0, 6)?.map((items, index) => {
                const today = new Date(); // Today's date
                const tomorrow = new Date();
                tomorrow.setDate(today.getDate() + 1);

                const checkinDay = today.getDate();
                const checkinMonth = today.getMonth() + 1;
                const checkinYear = today.getFullYear();

                const checkoutDay = tomorrow.getDate();
                const checkoutMonth = tomorrow.getMonth() + 1;
                const checkoutYear = tomorrow.getFullYear();
                return (
                  <SwiperSlide key={index}>
                    <a
                      onClick={() =>
                        scroll.scrollToTop({
                          duration: 500,
                          smooth: "easeInOutQuad",
                        })
                      }
                      href={`/single-hotel/${items?.hotel_slug}/${items?.hotel_id}?location=${items?.hotel_city}&room=1&adult=2&children=0&checkinDay=${checkinDay}&checkinMonth=${checkinMonth}&checkinYear=${checkinYear}&checkoutDay=${checkoutDay}&checkoutMonth=${checkoutMonth}&checkoutYear=${checkoutYear}&hotel_name=${items?.hotel_name}&hotel_address=${items?.hotel_address}`}
                      key={index}
                      className={styles.hotel_card}
                    >
                      {" "}
                      <div className={styles.img_sec}>
                        {items.hotel_image && items.hotel_image.length > 0 ? (
                          <img src={items?.hotel_image[0]} alt={items?.alt} />
                        ) : (
                          <img src={imgNotFound} alt="Image not found" />
                        )}
                      </div>
                      <div className={styles.content_sec}>
                        <div>
                          {" "}
                          <span>
                            {" "}
                            <svg
                              width="18"
                              height="18"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <mask
                                id="mask0_5983_7301"
                                style={{ maskType: "alpha" }}
                                maskUnits="userSpaceOnUse"
                                x="0"
                                y="0"
                                width="18"
                                height="18"
                              >
                                <rect width="18" height="18" fill="#D9D9D9" />
                              </mask>
                              <g mask="url(#mask0_5983_7301)">
                                <path
                                  d="M9.0013 8.89894C9.37443 8.89894 9.69343 8.76606 9.9583 8.50031C10.2233 8.23456 10.3558 7.91512 10.3558 7.542C10.3558 7.16887 10.2229 6.84981 9.95718 6.58481C9.69143 6.31994 9.37193 6.1875 8.99868 6.1875C8.62555 6.1875 8.30655 6.32038 8.04168 6.58613C7.77668 6.85188 7.64418 7.17138 7.64418 7.54463C7.64418 7.91775 7.77705 8.23675 8.0428 8.50163C8.30855 8.7665 8.62805 8.89894 9.0013 8.89894ZM8.99999 14.6351C10.4672 13.3216 11.5901 12.0618 12.3684 10.8555C13.1468 9.64925 13.536 8.59275 13.536 7.686C13.536 6.31875 13.1016 5.19475 12.2329 4.314C11.3641 3.43325 10.2865 2.99287 8.99999 2.99287C7.71349 2.99287 6.63586 3.43325 5.76711 4.314C4.89836 5.19475 4.46399 6.31875 4.46399 7.686C4.46399 8.59275 4.85318 9.64925 5.63155 10.8555C6.40993 12.0618 7.53274 13.3216 8.99999 14.6351ZM8.99999 16.1321C7.11249 14.4966 5.69711 12.9746 4.75386 11.5659C3.81061 10.1572 3.33899 8.86387 3.33899 7.686C3.33899 5.95525 3.8988 4.55406 5.01843 3.48244C6.13818 2.41081 7.46536 1.875 8.99999 1.875C10.5346 1.875 11.8618 2.41081 12.9816 3.48244C14.1012 4.55406 14.661 5.95525 14.661 7.686C14.661 8.86387 14.1894 10.1572 13.2461 11.5659C12.3029 12.9746 10.8875 14.4966 8.99999 16.1321Z"
                                  fill="#1C1B1F"
                                />
                              </g>
                            </svg>
                            {items.hotel_city}
                          </span>
                          <div className={styles.titleContainer} key={index}>
                            <h4
                              id={`title-${index}`}
                              className={styles.truncatedTitle}
                              style={{ padding: "0" }}
                            >
                              {items?.hotel_name}
                            </h4>
                            {truncationMap[index] && (
                              <span className={styles.fullTitle}>
                                {items?.hotel_name}
                              </span>
                            )}
                          </div>
                        </div>
                        <div>
                          {" "}
                          <span style={{ color: "#666666", textAlign: "end" }}>
                            {" "}
                            Starting From
                          </span>
                          <h3> {formatIndianCurrency(items.starting_price)}</h3>
                        </div>
                      </div>
                    </a>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
        )}
      </div>

      <div className="newui_view_all_btn_mobile_div">
        <Link to={"/all-hotels"} className="newui_view_all_btn_mobile">
          View All
        </Link>
      </div>
    </div>
  );
};

export default HotelCard;
